module.exports = __webpack_public_path__ + "static/media/virtual-reality-coding-middle-school.e6997d9f.webp";